export class CompletionEstimate {
  id?: number;
  version?: number;

  contractId?: number;
  clinId?: number;
  projectId?: number;
  invoicingPeriodId: number;

  estimatedCost: number;
  incurredCost: number;

  contractTitle?: string;
  clinName?: string;
  projectNumber?: string;
  projectName?: string;
}
